import { createContext, useMemo } from 'react';

// Where an app screen rendered in place should send its back link. The app's
// screens draw their own Header (via the components/common shim) but have no web
// route to point back to; the web wrapper that mounts one says, through this
// context, so the shared screen's header reads exactly like a web screen's.
export const ScreenChromeContext = createContext({
  backTo: null,
  backLabel: 'Back',
});

// The web page around an app screen rendered in place: the app shell, plus the
// back-link destination for the shared Header inside.
export function SharedScreen({
  backTo,
  backLabel = 'Back',
  className = '',
  children,
}) {
  const value = useMemo(() => ({ backTo, backLabel }), [backTo, backLabel]);
  return (
    <ScreenChromeContext.Provider value={value}>
      <main className={`app-shell screen ${className}`.trim()}>{children}</main>
    </ScreenChromeContext.Provider>
  );
}
